/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["@media screen{#print-content[_ngcontent-%COMP%], #print-page-break[_ngcontent-%COMP%], .print-content[_ngcontent-%COMP%]{display:none!important;visibility:hidden!important}}@media print{.p-dialog-width[_ngcontent-%COMP%]{width:100vw}}"];
export { styles as styles };

